/**
 * ════════════════════════════════════════════════════════════════════════
 * LOGGER DE DIAGNÓSTICO DO WELCOME WIZARD — INSTRUMENTAÇÃO TEMPORÁRIA
 * ════════════════════════════════════════════════════════════════════════
 * Objetivo: tornar QUALQUER problema do wizard visível só pelo console.
 * Loga renders, montagens, estado, props, dimensões e navegação.
 *
 * Para REMOVER tudo depois: apague este arquivo e os imports de `wlog`/`wdims`.
 * ════════════════════════════════════════════════════════════════════════
 */

let seq = 0;
const t0 = typeof performance !== 'undefined' ? performance.now() : 0;

const now = () =>
  ((typeof performance !== 'undefined' ? performance.now() : 0) - t0).toFixed(1);

/**
 * Log principal. wlog(area, evento, dados?)
 */
export const wlog = (area, event, data) => {
  seq += 1;
  const prefix = `%c WLC #${String(seq).padStart(4, '0')} %c ${now()}ms %c ${area} %c ${event}`;
  const s1 = 'background:#1a1a1a;color:#00e5ff;font-weight:bold';
  const s2 = 'background:#1a1a1a;color:#888';
  const s3 = 'background:#3949ab;color:#fff;font-weight:bold';
  const s4 = 'background:#1a1a1a;color:#aeea00';
  try {
    if (data !== undefined) {
      console.log(prefix, s1, s2, s3, s4, data);
    } else {
      console.log(prefix, s1, s2, s3, s4);
    }
  } catch {
    /* console pode falhar em ambientes restritos — ignora */
  }
};

/**
 * Loga as dimensões e o scroll de um elemento do DOM.
 */
export const wdims = (area, label, el) => {
  if (!el) {
    wlog(area, `DIMS[${label}]`, '⚠️ ELEMENTO NULO/INEXISTENTE');
    return;
  }
  try {
    const r = el.getBoundingClientRect();
    const cs = window.getComputedStyle(el);
    wlog(area, `DIMS[${label}]`, {
      x: Math.round(r.x),
      y: Math.round(r.y),
      w: Math.round(r.width),
      h: Math.round(r.height),
      top: Math.round(r.top),
      bottom: Math.round(r.bottom),
      scrollTop: el.scrollTop,
      scrollHeight: el.scrollHeight,
      clientHeight: el.clientHeight,
      display: cs.display,
      transform: cs.transform,
      overflow: cs.overflow,
      visibility: cs.visibility,
      opacity: cs.opacity,
    });
  } catch (e) {
    wlog(area, `DIMS[${label}]`, `⚠️ erro ao medir: ${e?.message}`);
  }
};

/**
 * Resumo enxuto do estado do wizard.
 */
export const wsnapshot = (state) => ({
  currentStepIndex: state?.currentStepIndex,
  stepsLen: state?.steps?.length,
  steps: state?.steps,
  themeId: state?.themeId,
  userName: state?.userName,
  locationName: state?.locationName,
  professionals: state?.professionals?.length,
  services: state?.services?.length,
  showSkip: state?.showSkip,
  isProcessing: state?.isProcessing,
  hasResult: !!state?.result,
  error: state?.error,
  completedAt: state?.completedAt,
});
